import { Button } from '../../common/Button';
import { AppleIcon } from '../../../assets/icons';
import { TranscriptionDemo } from '../TranscriptionDemo';
import styles from './Hero.module.css';

export const Hero = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.heroBadge}>
        <span className={styles.badgeDot}></span>
        Built for Apple Vision Pro
      </div>
      <h1>
        Hear the world,<br />
        <em>see the words</em>
      </h1>
      <p className={styles.heroSubtitle}>
        Solo Sense transforms spoken audio into beautiful, spatial captions that float right in front of you. Never miss a word again.
      </p>
      <div className={styles.heroCtas}>
        <Button variant="primary" icon={<AppleIcon />} href="https://apps.apple.com/us/app/solosense/id6742793439">
          Download on App Store
        </Button>
      </div>
      <TranscriptionDemo />
    </section>
  );
};
